import { render, staticRenderFns } from "./ViewQuiz.vue?vue&type=template&id=9ce2fcd0&scoped=true"
import script from "./ViewQuiz.vue?vue&type=script&lang=js"
export * from "./ViewQuiz.vue?vue&type=script&lang=js"
import style0 from "./ViewQuiz.vue?vue&type=style&index=0&id=9ce2fcd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2fcd0",
  null
  
)

export default component.exports